export function resolveSchoolDisplayName(schoolId, liveSchools = [], apiFallback = '') {
  const match = liveSchools.find((s) => String(s.id) === String(schoolId));
  const fromLive = match?.school_name || match?.name;
  if (fromLive) return fromLive;
  if (apiFallback && !/^School #\d+$/i.test(apiFallback.trim())) return apiFallback;
  return fromLive || apiFallback || `School #${schoolId}`;
}

export function enrichSchoolSummaries(rows, liveSchools = []) {
  return (rows || []).map((row) => ({
    ...row,
    school_name: resolveSchoolDisplayName(row.school_id, liveSchools, row.school_name),
  }));
}

export function enrichCohortCards(rows, liveSchools = []) {
  return (rows || []).map((row) => ({
    ...row,
    school_name: resolveSchoolDisplayName(row.school_id, liveSchools, row.school_name),
  }));
}

const SMOKE_SQUAD_PATTERN = /(smoke|pr[0-9]+\s|test\s*squad|e2e\s*squad)/i;

export function isSmokeTestSquadName(name) {
  return SMOKE_SQUAD_PATTERN.test(String(name || '').trim());
}

export function formatStudentDisplayName(name) {
  const raw = String(name || '').trim();
  if (!raw) return 'Unknown student';
  if (/^student #\d+$/i.test(raw)) return raw;
  if (raw === raw.toUpperCase() && raw.length > 3) {
    return raw
      .toLowerCase()
      .split(/\s+/)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  }
  return raw;
}

export function mapCohortStudentsFromSetup(setup, liveStudents = []) {
  const apiRows = setup?.students || [];
  if (apiRows.length > 0) {
    return apiRows.map((row) => {
      const id = String(row.id);
      const cached = liveStudents.find((s) => String(s.id) === id);
      const name = (row.name || cached?.name || '').trim();
      return {
        id,
        name: name || `Student #${id}`,
        grade: row.grade || cached?.grade || '',
      };
    });
  }
  return (setup?.student_ids || []).map((id) => {
    const key = String(id);
    const cached = liveStudents.find((s) => String(s.id) === key);
    return {
      id: key,
      name: cached?.name || `Student #${key}`,
      grade: cached?.grade || '',
    };
  });
}

export function chunkIntoColumns(items, perColumn = 5) {
  if (!items.length) return [];
  const columns = [];
  for (let i = 0; i < items.length; i += perColumn) {
    columns.push(items.slice(i, i + perColumn));
  }
  return columns;
}